export interface AuthStoreOptions {
  tokenKey: string;
  realmKey?: string;
}

export interface AuthStore {
  getToken(): string | null;
  setToken(token: string): void;
  clearToken(): void;
  getActiveRealm(): string | null;
  setActiveRealm(realmId: string): void;
}

export function createAuthStore(options: AuthStoreOptions): AuthStore {
  const { tokenKey, realmKey } = options;
  return {
    getToken: () => localStorage.getItem(tokenKey),
    setToken: (token: string) => localStorage.setItem(tokenKey, token),
    clearToken: () => {
      localStorage.removeItem(tokenKey);
      if (realmKey) localStorage.removeItem(realmKey);
    },
    getActiveRealm: () => (realmKey ? localStorage.getItem(realmKey) : null),
    setActiveRealm: (realmId: string) => {
      if (!realmKey) {
        throw new Error(
          "AuthStore: setActiveRealm called but realmKey is not configured",
        );
      }
      localStorage.setItem(realmKey, realmId);
    },
  };
}
